import { native as en_native } from "../en/native";

/** native — ES slice. */
export const native: Record<keyof typeof en_native, string> = {
  // Discover tab + nearby map
  native_discover_title: "Descubrir",
  native_discover_people_nearby: "Gente cerca",
  native_discover_finding_people: "Buscando gente cerca...",
  native_discover_start_swiping: "Desliza para conectar",
  native_discover_none_nearby:
    "No hay nadie cerca ahora. ¡Inténtalo más tarde!",
  native_discover_within_radius: "{count} {noun} en un radio de {radius} mi",
  native_discover_count_nearby: "{count} {noun} cerca",
  native_discover_person: "persona",
  native_discover_people: "personas",
  native_discover_location_unavailable: "Ubicación no disponible",
  native_discover_spots_nearby: "{count} lugares cerca",
  native_discover_map_mobile_only: "Mapa disponible en el móvil",

  // Settings — push notification status
  native_settings_push_not_supported: "No compatible con este dispositivo",
  native_settings_push_permission_denied: "Permiso denegado",
  native_settings_push_enabled: "Activadas",
  native_settings_push_disabled: "Desactivadas",

  // Settings — business section
  native_settings_business_section: "Negocio",
  native_settings_business_mode_title: "Modo Negocio",
  native_settings_business_mode_subtitle: "Crea o gestiona tu negocio",

  // Settings — mini apps section
  native_settings_mini_apps_section: "Mini Apps",
  native_settings_manage_mini_apps_title: "Gestionar Mini Apps",
  native_settings_manage_mini_apps_subtitle:
    "Ve, crea y gestiona tus mini apps",

  // Chat
  native_chat_no_messages_title: "Aún no hay mensajes",
  native_chat_no_messages_description:
    "Cuando hagas match con alguien, podrás empezar una conversación aquí",
  native_chat_tap_to_retry: "Toca para reintentar",

  // Match / filters / match-location
  native_match_approximate_location: "Ubicación aproximada",
  native_match_approximate_location_help:
    "Cuando está activado, los demás solo ven una zona aproximada cerca de ti, no tu ubicación exacta. Tu ubicación precisa nunca se comparte.",
  native_match_invalid_match: "Match no válido",
  native_match_you_label: "Tú:",

  // Mini app view
  native_miniapp_load_failed: "No se pudo cargar {appId}",
  native_miniapp_retry: "Reintentar",
};
